import React from 'react';
import { Box } from '@mui/material';
import { DraggableTooltipContainer } from 'spw-components/worksheet/styles';
import { TooltipTitle, TooltipText } from './styles';

const VacancyFactorGuide: React.FC = () => (
  <DraggableTooltipContainer>
    <TooltipTitle id="draggable-dialog-title" className="title">
      Vacancy Factor Tips
    </TooltipTitle>

    <div className="content">
      <TooltipText>
        What percentage of job positions (headcount) have been budgeted for but
        are currently unfilled?
      </TooltipText>

      <Box marginTop="8px">
        <TooltipText>
          We recommend using this approximate value as a buffer to account for
          expected headcount that is not yet hired.
        </TooltipText>
      </Box>

      <Box marginTop="8px">
        <TooltipText>
          This input is optional and typically ranges from 1 - 5%.
        </TooltipText>
      </Box>
    </div>
  </DraggableTooltipContainer>
);

export default VacancyFactorGuide;
